<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Pakowanie</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/order/send">Wysyłka zamówień</router-link>
        </li>
        <li class="active">
          <strong>Pakowanie</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <!-- Spinner ładowania -->
    <div class="row" v-if="loading">
      <div class="col-sm-12 text-center">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <button @click="getAdminCard" class="btn btn-primary">
          <i class="fa fa-file"></i>
          Pobierz kartę zamówienia
        </button>

        <!-- Punkt odbioru GLS -->
        <div class="ibox" v-if="canDisplayPointCollectionField">
          <div class="ibox-content">
            <div class="row">
              <div class="col-md-6">
                <label>Punkt odbioru</label>
                <select
                  class="form-control"
                  v-model="adminData.collection_point_suffix"
                  @change="onCollectionPointChange"
                >
                  <option
                    v-for="cp in collectionPoints"
                    :key="cp.value"
                    :value="cp.value"
                  >
                    {{ cp.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="(dData, index) in deliveryData?.delivery_addresses"
          class="ibox float-e-margins"
          :key="`${dData.pk ?? index}-${isLabelLoading(
            dData
          )}-${isGenerateLabel(dData)}`"
        >
          <div class="ibox-title">
            <h5>Adres dostawy nr. {{ index + 1 }}</h5>
            <button
              v-if="isGenerateLabel(dData)"
              :key="`generate-label-btn-${dData.pk}`"
              type="button"
              class="btn-like-link"
              @click="generateLabel(dData)"
              :disabled="isLabelLoading(dData)"
            >
              <span>{{ getGenerateLabelText() }}</span>
              <span
                v-if="isLabelLoading(dData)"
                class="fa fa-spinner fa-spin"
              ></span>
            </button>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <!-- Status przesyłki Allegro -->
              <div class="row">
                <div class="col-lg-4">
                  <div
                    class="shipment-details"
                    v-if="isAllegroSource() && dData.detail"
                  >
                    <h4>
                      Status tworzenia przesyłki:
                      <span class="badge badge-secondary">{{
                        dData.detail.cmd.status_name
                      }}</span>
                      <span
                        v-if="isShipmentInProgress(dData)"
                        class="fa fa-spinner fa-spin"
                      ></span>
                    </h4>
                    <ul class="shipment-errors" v-if="dData.detail.cmd.errors">
                      <li
                        class="shipment-error"
                        v-for="(error, i) in dData.detail.cmd.errors"
                        :key="i"
                      >
                        {{ error.userMessage }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  v-for="(adress, index1) in dData?.delivery_packages"
                  :key="`${adress.pk ?? index1}-${isConfirmLoading(
                    adress.pk
                  )}-${isConfirmDeliveryPackage(adress)}`"
                  class="col-lg-4"
                >
                  <h3>
                    <span>{{ adress.package.name }}</span>
                    <button
                      v-if="isConfirmDeliveryPackage(adress)"
                      :key="`confirm-package-btn-${adress.pk}`"
                      type="button"
                      class="btn-like-link"
                      @click="confirmDeliveryPackage(adress)"
                      :disabled="isConfirmLoading(adress.pk)"
                    >
                      <span>| Potwierdź zapakowanie</span>
                      <span
                        v-if="isConfirmLoading(adress.pk)"
                        class="fa fa-spinner fa-spin"
                      ></span>
                    </button>
                    <a
                      v-if="isInProduction() && isPrintLabel(adress)"
                      :key="`print-label-link-${adress.pk}`"
                      href="#"
                      class="btn-like-link"
                      @click.prevent="printLabel(adress)"
                    >
                      {{ getPrintBtnName(adress) }}
                    </a>
                  </h3>
                  <p class="small">
                    <i class="fa fa-truck"></i>
                    <span>{{ adress.package.height }}</span>
                    <i class="fa fa-times"></i>
                    <span>{{ adress.package.width }}</span>
                    <i class="fa fa-times"></i>
                    <span>{{ adress.package.length }}</span>
                    <span>[cm]</span>
                  </p>
                  <!-- Numer śledzenia -->
                  <p class="small" v-if="adress.tracking_number">
                    <i class="fa fa-map-marker"></i>
                    <span>{{ adress.tracking_number }}</span>
                  </p>
                  <ul class="sortable-list agile-list">
                    <li
                      v-for="(product, index2) in adress?.products"
                      :key="product.product_pk ?? index2"
                      class="success-element"
                    >
                      <span class="label label-primary">
                        {{ product.product_pk }}
                      </span>
                      <span class="ng-binding">{{ product.product_name }}</span>
                    </li>
                  </ul>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="ibox float-e-margins">
                      <div class="ibox-title">
                        <h5>Zawartość adresu</h5>
                        <div v-if="dData?.products" class="ibox-content">
                          <EasyDataTable
                            :key="`${dData.pk}-${dData.products.length}`"
                            :headers="headers"
                            :items="dData.products"
                            show-index
                            :clickRowToExpand="false"
                            :loading="loading"
                            alternating
                            multi-sort
                            border-cell
                            class="table-search"
                          >
                            <template #header="header">
                              <span v-if="header.text">{{ header.text }}</span>
                              <input
                                class="table-search"
                                type="text"
                                v-if="header.search"
                                v-model="searchValue[header.value]"
                                @keyup="search"
                                @click="isSearch = true"
                              />
                            </template>
                            <template #item-actions="item">
                              <button
                                :disabled="isClientFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    item.product_file.pk,
                                    '/get_client_file/'
                                  )
                                "
                                class="btn btn-xs"
                                title="Plik Klienta"
                              >
                                <i class="fa fa-user"></i>
                              </button>
                              <button
                                :disabled="isResultFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    item.product_file.pk,
                                    '/get_result_file/'
                                  )
                                "
                                class="btn btn-xs"
                                title="Plik wyjściowy"
                              >
                                <i class="fa fa-search"></i>
                              </button>
                              <button
                                v-if="!isClientCoverFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    item.product_file.pk,
                                    '/get_client_cover_file/'
                                  )
                                "
                                class="btn btn-xs"
                                title="Plik okładki klienta"
                              >
                                <i class="fa fa-user"></i>
                              </button>
                              <button
                                v-if="!isCoverResultFileNotAvailable(item)"
                                @click="
                                  getOrderProductFiles(
                                    item.product_file.pk,
                                    '/get_cover_result_file/'
                                  )
                                "
                                class="btn btn-xs"
                                title="Plik okładki wyjściowy"
                              >
                                <i class="fa fa-search"></i>
                              </button>
                            </template>
                            <template #item-preview="item">
                              <img
                                v-if="item.product_file"
                                :src="item.product_file.client_file_thumbnail"
                                width="40px"
                              />
                              <span v-else>—</span>
                            </template>
                            <template #item-weight="item">
                              <input
                                v-model="weight[item.pk]"
                                @input="convertCommaToDot(item.pk)"
                                @blur="handleWeight(item.pk)"
                                type="text"
                                class="form-control inputClass"
                                placeholder="Waga"
                                required="required"
                              />
                              {{ item.weight }}
                            </template>
                          </EasyDataTable>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useCookies } from "vue3-cookies";
import {
  orderSourceConst,
  orderShipmentCmdStatusConst,
  orderStatusConst,
} from "../../constants/orderConstants";

export default {
  name: "OrderPacking",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const orderId = ref();
    const errorsAdminData = ref();
    const showErrors = ref(false);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { cookies } = useCookies();

    const realWeightData = computed(() => store.getters.getRealWeightData);
    const adminSendUpsData = computed(() => store.getters.getAdminSendUpsData);
    const confirmDeliveryPackageData = computed(
      () => store.getters.getConfirmDeliveryPackageData
    );
    const orderProductFilesData = computed(
      () => store.getters.getOrderProductFilesData
    );
    // Admin (do sufiksu punktu odbioru GLS) — pobierany po pk z cookie CPid
    const adminEditData = computed(() => store.getters.getAdminEditData);
    // Punkty odbioru GLS
    const collectionPointsData = computed(
      () => store.getters.getCollectionPointsData
    );

    const deliveryData = ref();
    const weight = ref([]);
    const confirmLoading = ref({});
    const printedPackages = ref({});

    // Stany ładowania i punktu odbioru
    const loading = ref(true);
    const initialLoadDone = ref(false);
    const labelLoading = ref({});
    const canDisplayPointCollectionField = ref(false);
    const collectionPoints = ref([]);
    const adminData = ref({ collection_point_suffix: "" });

    let headers = [
      { text: "Podgląd", value: "preview" },
      { text: "ID zlecenia", value: "order_product" },
      { text: "Produkt", value: "product_name" },
      { text: "Nakład", value: "amount" },
      { text: "Waga", value: "weight" },
      { text: "Akcje", value: "actions" },
    ];

    const getAdminCard = () => {
      if (route.params?.pk) {
        store.dispatch("getOrderAdminCard", route.params?.pk);
      }
    };

    const isGenerateLabel = (deliveryAddress) => {
      if (!deliveryData.value) {
        return false;
      }
      if (
        deliveryData.value.is_ups_self_pickup ||
        deliveryData.value.is_self_pickup
      ) {
        return false;
      }
      if (
        !deliveryAddress?.delivery_packages ||
        deliveryAddress.delivery_packages.length === 0
      ) {
        return false;
      }
      const packagesWithTracking = deliveryAddress.delivery_packages.filter(
        (item) => item.tracking_number
      );
      return (
        packagesWithTracking.length !== deliveryAddress.delivery_packages.length
      );
    };

    const getGenerateLabelText = () => {
      if (
        deliveryData.value?.is_self_pickup ||
        deliveryData.value?.is_ups_self_pickup
      ) {
        return "| Wygeneruj etykiety wewnętrzne";
      }
      return "| Wygeneruj listy przewozowe";
    };

    const isLabelLoading = (deliveryAddress) => {
      return !!labelLoading.value[deliveryAddress?.pk];
    };

    const isAllegroSource = () => {
      return deliveryData.value?.source === orderSourceConst.allegro.value;
    };

    const isShipmentInProgress = (deliveryAddress) => {
      return (
        deliveryAddress?.detail &&
        deliveryAddress.detail.cmd?.status ===
          orderShipmentCmdStatusConst.in_progress.value
      );
    };

    const refreshOrder = async () => {
      if (route.params?.pk) {
        await store.dispatch("adminSendUpsRetrieve", route.params.pk);
      }
    };

    const longPoll = async (interval) => {
      await refreshOrder();

      let continuePolling = false;
      for (const address of deliveryData.value?.delivery_addresses || []) {
        if (isShipmentInProgress(address) || !address.ups_tracking_number) {
          continuePolling = true;
          break;
        }
      }

      if (continuePolling) {
        setTimeout(() => longPoll(interval), interval);
      } else {
        deliveryData.value?.delivery_addresses?.forEach((address) => {
          labelLoading.value[address.pk] = false;
        });
      }
    };

    const longPollInpost = async (interval) => {
      await refreshOrder();

      let continuePolling = false;
      for (const address of deliveryData.value?.delivery_addresses || []) {
        for (const pkg of address.delivery_packages || []) {
          if (!pkg.tracking_number) {
            continuePolling = true;
            break;
          }
        }
        if (continuePolling) break;
      }

      if (continuePolling) {
        setTimeout(() => longPollInpost(interval), interval);
      } else {
        deliveryData.value?.delivery_addresses?.forEach((address) => {
          labelLoading.value[address.pk] = false;
        });
        store.dispatch("showToaster", {
          type: "success",
          content: "Etykiety zostały pomyślnie wygenerowane.",
        });
      }
    };

    const generateLabel = async (deliveryAddress) => {
      if (!deliveryAddress || !deliveryAddress.pk) return;

      labelLoading.value[deliveryAddress.pk] = true;

      try {
        await store.dispatch("generateLabel", deliveryAddress.pk);
        await refreshOrder();

        if (isAllegroSource()) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Pomyślnie przesłano dane do wygenerowania przesyłki.",
          });
          longPoll(5000);
        } else if (deliveryData.value?.is_inpost_delivery_service) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Pomyślnie utworzono nową przesyłkę w InPost.",
          });
          longPollInpost(5000);
        } else {
          store.dispatch("showToaster", {
            type: "success",
            content:
              "Etykiety adresowe oraz numery trackingowe zostały pomyślnie wygenerowane.",
          });
          labelLoading.value[deliveryAddress.pk] = false;
        }
      } catch (error) {
        labelLoading.value[deliveryAddress.pk] = false;

        var msg = [];
        if (
          error?.data?.nonFieldErrors &&
          Array.isArray(error.data.nonFieldErrors)
        ) {
          msg = msg.concat(error.data.nonFieldErrors);
        }
        for (const value of Object.entries(error?.data || {})) {
          if (value[0] !== "nonFieldErrors") {
            if (Array.isArray(value[1])) {
              msg = msg.concat(value[1]);
            } else {
              msg.push(value[1]);
            }
          }
        }

        store.dispatch("showToaster", {
          type: "error",
          content:
            msg.length > 0
              ? msg[0]
              : "Podczas generowania etykiety adresowej wystąpił błąd",
        });
        errorsAdminData.value = error;
      }
    };

    const isInProduction = () => {
      const status = deliveryData.value?.status;
      if (!status) return false;
      return status === orderStatusConst.in_production.value;
    };

    const isConfirmDeliveryPackage = (deliveryPackage) => {
      if (!deliveryData.value || !deliveryPackage) return false;
      if (
        deliveryData.value.is_ups_self_pickup ||
        deliveryData.value.is_self_pickup
      ) {
        return !deliveryPackage.is_packed;
      }
      return !deliveryPackage.is_packed && !!deliveryPackage.tracking_number;
    };

    const isConfirmLoading = (pk) => {
      return confirmLoading.value[pk] || false;
    };

    const confirmDeliveryPackage = (deliveryPackage) => {
      if (!deliveryPackage || !deliveryPackage.pk) return;
      confirmLoading.value[deliveryPackage.pk] = true;
      store.dispatch("confirmDeliveryPackage", deliveryPackage.pk);
    };

    const isPrintLabel = (deliveryPackage) => {
      if (!deliveryData.value || !deliveryPackage) return false;
      if (
        deliveryData.value.is_ups_self_pickup ||
        deliveryData.value.is_self_pickup
      ) {
        return false;
      }
      return !!deliveryPackage.is_packed && !!deliveryPackage.tracking_number;
    };

    const isPrintAvailable = (deliveryPackage) => {
      return !printedPackages.value[deliveryPackage?.pk];
    };

    const getPrintBtnName = (deliveryPackage) => {
      if (!deliveryPackage?.pk) return "| Drukuj";
      return printedPackages.value[deliveryPackage.pk]
        ? "| Drukuj ponownie"
        : "| Drukuj";
    };

    const printImage = (base64Image, width, height) => {
      const printWindow = window.open("", "_blank");
      if (!printWindow) return;

      if (width && height) {
        printWindow.document.write(
          `<img width="${width}px" height="${height}px" src="${base64Image}"/>`
        );
      } else {
        printWindow.document.write(`<img src="${base64Image}"/>`);
      }

      printWindow.document.close();
      printWindow.setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 200);
    };

    const printLabel = async (deliveryPackage) => {
      if (!deliveryPackage?.pk) return;
      try {
        const response = await store.dispatch(
          "printDeliveryPackageLabel",
          deliveryPackage.pk
        );
        const data = response?.data;

        printedPackages.value[deliveryPackage.pk] = true;

        if (data?.is_inpost_delivery) {
          printImage(data.label_image, 397, 559);
        } else if (
          data?.is_gls_delivery ||
          data?.is_self_pickup_delivery ||
          isAllegroSource()
        ) {
          printImage(data.label_image, 339, 566);
        } else {
          printImage(data?.label_image);
        }
      } catch (error) {
        store.dispatch("showToaster", {
          type: "error",
          content: "Podczas drukowania etykiety wystąpił błąd",
        });
      }
    };

    const convertCommaToDot = (pk) => {
      if (pk && weight.value && weight.value[pk]) {
        weight.value[pk] = weight.value[pk].toString().replace(",", ".");
      }
    };

    const handleWeight = (pk) => {
      if (pk && weight.value) {
        const weightValue = weight.value[pk]
          ? weight.value[pk].toString().replace(",", ".")
          : weight.value[pk];
        store.dispatch("upsUpdateRealWeight", {
          pk: pk,
          real_weight: weightValue,
        });
      }
    };

    const getOrderProductFiles = (pk, type) => {
      if (pk && weight.value) {
        store.dispatch("getOrderProductFiles", { pk: pk, type: type });
      }
    };

    // The client and result file buttons stay visible and go grey when there is nothing to
    // download, the cover ones are hidden instead - same as in the admin panel.
    const isClientFileNotAvailable = (item) =>
      !item?.product_file?.client_file_url;
    const isResultFileNotAvailable = (item) =>
      !item?.product_file?.preflight_result;
    const isClientCoverFileNotAvailable = (item) =>
      !item?.product_file?.client_cover_file_url;
    const isCoverResultFileNotAvailable = (item) =>
      !item?.product_file?.cover_preflight_result;

    const isCanDisplayPointCollectionField = () => {
      const isLabelsGenerated = deliveryData.value?.delivery_addresses?.some(
        (addr) => addr.ups_tracking_number !== null
      );
      return (
        deliveryData.value?.is_gls_delivery_service &&
        !isLabelsGenerated &&
        collectionPoints.value.length > 1
      );
    };

    const getCollectionPoints = async () => {
      loading.value = true;
      try {
        await store.dispatch("getCollectionPoints");
        collectionPoints.value = collectionPointsData.value?.data || [];
        canDisplayPointCollectionField.value =
          isCanDisplayPointCollectionField();
      } finally {
        loading.value = false;
      }
    };

    const getAdmin = async () => {
      loading.value = true;
      try {
        const adminPk = cookies.get("CPid");
        if (!adminPk) {
          return;
        }
        await store.dispatch("getAdmin", { pk: adminPk });
        adminData.value = adminEditData.value?.data || {};
        if (adminData.value.collection_point_suffix == null) {
          adminData.value.collection_point_suffix = "";
        }
      } finally {
        loading.value = false;
      }
    };

    const onCollectionPointChange = () => {
      store.dispatch("updateAdmin", {
        pk: adminData.value.pk,
        collection_point_suffix: adminData.value.collection_point_suffix,
      });
    };

    if (route.params?.pk) {
      loading.value = true;
      store.dispatch("adminSendUpsRetrieve", route.params?.pk);
    }

    watch(
      () => adminSendUpsData.value,
      function (newValue) {
        deliveryData.value = newValue.data;

        newValue.data.delivery_addresses?.forEach((element) => {
          element.products?.forEach((elem) => {
            weight.value[elem.pk] = elem.real_weight;
          });
        });

        if (!initialLoadDone.value) {
          initialLoadDone.value = true;

          if (!isInProduction()) {
            loading.value = false;
            router.push({ name: "OrderSend" }).then(() => {
              store.dispatch("showToaster", {
                type: "error",
                content:
                  'Wysłane mogą być tylko zamówienia ze statusem "W produkcji"',
              });
            });
            return;
          }

          Promise.all([getAdmin(), getCollectionPoints()]).finally(() => {
            loading.value = false;
          });
        }
      }
    );

    watch(
      () => realWeightData.value,
      function (newValue) {
        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Waga produktu została pomyślnie zapisana.",
          });
        } else {
          var msg = [];
          for (const value of Object.entries(newValue.data)) {
            msg.push(value);
          }
          store.dispatch("showToaster", { type: "error", content: msg[0] });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => orderProductFilesData.value,
      function (newValue) {
        if (newValue.status !== 200) {
          store.dispatch("showToaster", {
            type: "error",
            content: newValue.response.statusText,
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => confirmDeliveryPackageData.value,
      function (newValue) {
        if (!newValue) return;

        let packagePk = null;
        if (deliveryData.value?.delivery_addresses) {
          for (const addr of deliveryData.value.delivery_addresses) {
            if (addr.delivery_packages) {
              for (const pkg of addr.delivery_packages) {
                if (confirmLoading.value[pkg.pk]) {
                  packagePk = pkg.pk;
                  break;
                }
              }
              if (packagePk) break;
            }
          }
        }

        if (packagePk) confirmLoading.value[packagePk] = false;

        if (newValue.status === 200) {
          if (packagePk && deliveryData.value?.delivery_addresses) {
            for (const addr of deliveryData.value.delivery_addresses) {
              if (addr.delivery_packages) {
                const pkg = addr.delivery_packages.find(
                  (p) => p.pk === packagePk
                );
                if (pkg) pkg.is_packed = true;
              }
            }
          }
          store.dispatch("showToaster", {
            type: "success",
            content: "Paczka została pomyślnie potwierdzona.",
          });
        } else {
          var msg = [];
          if (
            newValue.data?.nonFieldErrors &&
            Array.isArray(newValue.data.nonFieldErrors)
          ) {
            msg = msg.concat(newValue.data.nonFieldErrors);
          }
          for (const value of Object.entries(newValue.data || {})) {
            if (value[0] !== "nonFieldErrors") {
              if (Array.isArray(value[1])) {
                msg = msg.concat(value[1]);
              } else {
                msg.push(value[1]);
              }
            }
          }
          if (msg.length > 0) {
            store.dispatch("showToaster", { type: "error", content: msg[0] });
          } else {
            store.dispatch("showToaster", {
              type: "error",
              content: "Podczas potwierdzania paczki wystąpił błąd",
            });
          }
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      errorsAdminData,
      showErrors,
      orderId,
      loading,
      getAdminCard,
      deliveryData,
      headers,
      generateLabel,
      isGenerateLabel,
      getGenerateLabelText,
      isLabelLoading,
      isInProduction,
      isAllegroSource,
      isShipmentInProgress,
      confirmDeliveryPackage,
      isConfirmDeliveryPackage,
      isConfirmLoading,
      isPrintLabel,
      isPrintAvailable,
      printLabel,
      getPrintBtnName,
      handleWeight,
      convertCommaToDot,
      weight,
      getOrderProductFiles,
      isClientFileNotAvailable,
      isResultFileNotAvailable,
      isClientCoverFileNotAvailable,
      isCoverResultFileNotAvailable,
      canDisplayPointCollectionField,
      collectionPoints,
      adminData,
      onCollectionPointChange,
    };
  },
  computed: {},
};
</script>
